import { render } from "./RankingTopic.vue?vue&type=template&id=f8bad232&scoped=true"
import script from "./RankingTopic.vue?vue&type=script&lang=js"
export * from "./RankingTopic.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=f8bad232&lang=css&scoped=true"
import "@/assets/css/style_ranking.css?vue&type=style&index=1&id=f8bad232&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bad232"]])

export default __exports__